import {OptionHTMLAttributes} from 'react';
import {IntlShape, useIntl} from 'react-intl';
import Select from '../../../app/common/components/select/Select';
import {ReclamationTypes} from '../Type/reclamation';
import {SetFieldValue} from "../../../app/types/Forms";
import {usePermissions} from "../../../app/modules/auth/authorization/PermissionProvider";

interface SelectTypeProps {
  name?: string;
  value?: OptionHTMLAttributes<string>;
  setFieldValue: SetFieldValue;
  isLoading?: boolean;
  touched?: boolean;
  errors?: string;
}

export const getTypeOptions = (intl: IntlShape): OptionHTMLAttributes<string>[] => [
  {
    label: intl.formatMessage({id: 'ADMINISTRATIVE.RECLAMATIONS.TYPE.ADMINISTRATIVE'}),
    value: ReclamationTypes.ADMINISTRATIVE,
  },
  {
    label: intl.formatMessage({id: 'ADMINISTRATIVE.RECLAMATIONS.TYPE.TECHNICAL'}),
    value: ReclamationTypes.TECHNICAL,
  },
];

const SelectType = ({
                      name,
                      value,
                      setFieldValue,
                      isLoading,
                      touched,
                      errors,
                    }: SelectTypeProps): JSX.Element => {
  const intl = useIntl();
  let reasonOptions = getTypeOptions(intl);

  const userPermissions = usePermissions();

  const canSeeTechnical = !!userPermissions?.includes?.('voirTicketTechnique');
  const canSeeAdmin = !!userPermissions?.includes?.('voirAdministratifFacture');

  if(canSeeAdmin && !canSeeTechnical) {
    reasonOptions = reasonOptions.filter(option => option.value === ReclamationTypes.ADMINISTRATIVE);
  }

  if(canSeeTechnical && !canSeeAdmin) {
    reasonOptions = reasonOptions.filter(option => option.value === ReclamationTypes.TECHNICAL);
  }


  return (
    <Select<OptionHTMLAttributes<string>>
      label={intl.formatMessage({id: 'ADMINISTRATIVE.RECLAMATIONS.TYPE'})}
      isDisabled={isLoading}
      isLoading={isLoading}
      isClearable={false}
      isSearchable={false}
      name={name}
      onChange={(type) => {
        setFieldValue('type', type);
      }}
      value={value}
      getOptionValue={(option) => option.value?.toString() ?? ''}
      getOptionLabel={(option) => option.label ?? ''}
      options={reasonOptions}
      placeholder={intl.formatMessage({id: 'ADMINISTRATIVE.RECLAMATIONS.TYPE.PLACEHOLDER'})}
      touched={touched}
      error={errors}
    />
  );
};

export default SelectType;
